import React from 'react';
import Card from 'react-bootstrap/Card';

import styles from '../styles/elements/Dialog.module.scss';

const Dialog = (props) => {

    const {question, actionTitle, cancelTitle, action, cancel, param, response} = props;

    const handleAction = () => { param ? action(param) : action()};

    const confirmation = <Card.Body>
                            <Card.Title>{question}</Card.Title>
                            <Card.Link as="button" className="btn btn-primary" onClick={handleAction}>{actionTitle}</Card.Link>
                            <Card.Link as="button" className="btn btn-outline-primary" onClick={cancel}>{cancelTitle}</Card.Link>
                        </Card.Body>;

    const responseLine = <Card.Body>
                        <Card.Title>{response}</Card.Title>
                        <Card.Link as="button" className="btn btn-outline-primary" onClick={cancel}>Închide</Card.Link>
                    </Card.Body>;


    return (
        <section className={styles.root}>
            <Card className="w-100 px-md-5 py-md-3 p-0">
                {response ? responseLine : confirmation}
            </Card>
        </section>
    );
}

export default Dialog;